function digitsOnly(phone) {
    return String(phone || '').replace(/\D/g, '');
}

function whatsappUrlForPhone(phone, options = {}) {
    const d = digitsOnly(phone);
    if (!d) return null;
    let national = d;
    if (d.startsWith('57')) {
        national = d.slice(2);
    }
    if (national.length === 10 && national.startsWith('3')) {
        const base = `https://wa.me/57${national}`;
        const text = options.text != null ? String(options.text).trim() : '';
        if (text) {
            return `${base}?text=${encodeURIComponent(text)}`;
        }
        return base;
    }
    return null;
}

function telUrlForPhone(phone) {
    const d = digitsOnly(phone);
    if (!d) return null;
    if (d.startsWith('57')) return `tel:+${d}`;
    if (d.length === 10) return `tel:+57${d}`;
    return `tel:+${d}`;
}

export { digitsOnly, whatsappUrlForPhone, telUrlForPhone };
